import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ContratoRenegociacao } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContratoRenegociacaoService extends BaseResourceService<ContratoRenegociacao> {

  constructor(
    protected injector: Injector
  ) {
    super(`contrato-renegociacaos`, injector);
  }

  public salvarLista(renegociacaos: ContratoRenegociacao[]): Observable<ContratoRenegociacao[]> {
    return this.http.post(`${this.login.cidade.id}/${this.api}/salvar-lista`, renegociacaos, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }
}
